import React from "react"
import { useI18next } from "@zestia/gatsby-plugin-react-i18next"
import { Link } from "gatsby"
import G2Stars from "../svg/G2Stars"
import Countdown from "react-countdown"

const NavBarKicker = ({ isSpecialOffer }) => {
  const { t } = useI18next()

  const targetDate = new Date("2024-11-29T23:59:00")

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <span>Offer has ended!</span>
    } else {
      return (
        <div className="nav-bar-kicker__countdown">
          <span className="nav-bar-kicker__countdown-item">{days} days</span>
          <span className="nav-bar-kicker__countdown-item">{hours} hours</span>
          <span className="nav-bar-kicker__countdown-item">
            {minutes} minutes
          </span>
          <span className="nav-bar-kicker__countdown-item">
            {seconds} seconds
          </span>
        </div>
      )
    }
  }

  return (
    <div className="nav-bar-kicker">
      {isSpecialOffer ? (
        <div className="nav-bar-kicker__special-offer">
          <p className="mb-0 nav-bar-kicker__title">Black Friday Offer</p>
          <p className="mb-0 nav-bar-kicker__description">
            Get 20% off Capsule for 3 months
          </p>

          <Countdown date={targetDate} renderer={renderer} />
        </div>
      ) : (
        <>
          <a
            className="nav-bar-kicker__left"
            href="https://www.g2.com/products/capsule-crm/reviews"
            target="_blank"
          >
            <G2Stars />
            {t("sales-resources.reviews.one")}
          </a>
          <div className="nav-bar-kicker__right">
            <Link to="/partner-program/">
              {t("affiliate.become-a-partner")}
            </Link>
            <Link
              to="/contact-sales/"
              className="nav-bar-kicker__contact-sales"
            >
              {t("sales-resources.contact-sales")}
            </Link>
          </div>
        </>
      )}
    </div>
  )
}

export default NavBarKicker
